import { COLUMN_CONSTRAINTS, COLUMN_DATATYPES } from '../constants/column';

export const dataTypeOptions = [
  { value: 'TINYINT', label: 'TINYINT' },
  { value: 'SMALLINT', label: 'SMALLINT' },
  { value: 'MEDIUMINT', label: 'MEDIUMINT' },
  { value: 'INT', label: 'INT' },
  { value: 'BIGINT', label: 'BIGINT' },
  { value: 'FLOAT', label: 'FLOAT' },
  { value: 'DOUBLE', label: 'DOUBLE' },
  { value: 'DECIMAL', label: 'DECIMAL' },
  { value: 'NUMERIC', label: 'NUMERIC' },
  { value: 'BINARY_FLOAT', label: 'BINARY_FLOAT' },
  { value: 'BINARY_DOUBLE', label: 'BINARY_DOUBLE' },
  { value: 'DOUBLE_PRECISION', label: 'DOUBLE_PRECISION' },
  { value: 'REAL', label: 'REAL' },
  { value: 'CHAR', label: 'CHAR' },
  { value: 'NCHAR', label: 'NCHAR' },
  { value: 'VARCHAR', label: 'VARCHAR' },
  { value: 'NVARCHAR', label: 'NVARCHAR' },
  { value: 'VARCHAR2', label: 'VARCHAR2' },
  { value: 'NVARCHAR2', label: 'NVARCHAR2' },
  { value: 'TINYTEXT', label: 'TINYTEXT' },
  { value: 'TEXT', label: 'TEXT' },
  { value: 'NTEXT', label: 'NTEXT' },
  { value: 'MEDIUMTEXT', label: 'MEDIUMTEXT' },
  { value: 'LONG', label: 'LONG' },
  { value: 'LONGTEXT', label: 'LONGTEXT' },
  { value: 'ENUM', label: 'ENUM' },
  { value: 'SET', label: 'SET' },
  { value: 'DATE', label: 'DATE' },
  { value: 'DATETIME', label: 'DATETIME' },
  { value: 'DATETIME2', label: 'DATETIME2' },
  { value: 'SMALLDATETIME', label: 'SMALLDATETIME' },
  { value: 'DATETIMEOFFSET', label: 'DATETIMEOFFSET' },
  { value: 'TIMESTAMP', label: 'TIMESTAMP' },
  { value: 'TIME', label: 'TIME' },
  { value: 'YEAR', label: 'YEAR' },
  { value: 'BINARY', label: 'BINARY' },
  { value: 'VARBINARY', label: 'VARBINARY' },
  { value: 'TINYBLOB', label: 'TINYBLOB' },
  { value: 'MEDIUMBLOB', label: 'MEDIUMBLOB' },
  { value: 'BLOB', label: 'BLOB' },
  { value: 'LONGBLOB', label: 'LONGBLOB' },
  { value: 'CLOB', label: 'CLOB' },
  { value: 'NCLOB', label: 'NCLOB' },
  { value: 'BFILE', label: 'BFILE' },
  { value: 'RAW', label: 'RAW' },
  { value: 'LONGRAW', label: 'LONGRAW' },
  { value: 'BOOL', label: 'BOOL' },
  { value: 'BOOLEAN', label: 'BOOLEAN' },
  { value: 'BIT', label: 'BIT' },
];

export const oracleDataTypeOptions = [
  { value: 'NUMBER', label: 'NUMBER' },
  { value: 'VARCHAR2', label: 'VARCHAR2' },
  { value: 'CHAR', label: 'CHAR' },
  { value: 'NVARCHAR2', label: 'NVARCHAR2' },
  { value: 'NCHAR', label: 'NCHAR' },
  { value: 'LONG', label: 'LONG' },
  { value: 'LONG RAW', label: 'LONG RAW' },
  { value: 'RAW', label: 'RAW' },
  { value: 'ROWID', label: 'ROWID' },
  { value: 'UROWID', label: 'UROWID' },
  { value: 'FLOAT', label: 'FLOAT' },
  { value: 'BINARY_FLOAT', label: 'BINARY_FLOAT' },
  { value: 'BINARY_DOUBLE', label: 'BINARY_DOUBLE' },
  { value: 'DATE', label: 'DATE' },
  { value: 'TIMESTAMP', label: 'TIMESTAMP' },
  {
    value: 'TIMESTAMP WITH LOCAL TIME ZONE',
    label: 'TIMESTAMP WITH LOCAL TIME ZONE',
  },
  { value: 'TIMESTAMP WITH TIME ZONE', label: 'TIMESTAMP WITH TIME ZONE' },
  { value: 'INTERVAL YEAR TO MONTH', label: 'INTERVAL YEAR TO MONTH' },
  { value: 'INTERVAL DAY TO SECOND', label: 'INTERVAL DAY TO SECOND' },
  { value: 'BLOB', label: 'BLOB' },
  { value: 'CLOB', label: 'CLOB' },
  { value: 'NCLOB', label: 'NCLOB' },
  { value: 'BFILE', label: 'BFILE' },
  { value: 'BINARY_DOUBLE', label: 'BINARY_DOUBLE' },
  { value: 'BINARY_FLOAT', label: 'BINARY_FLOAT' },
];

export const mysqlDataTypeOptions = [
  { value: 'TINYINT', label: 'TINYINT' },
  { value: 'SMALLINT', label: 'SMALLINT' },
  { value: 'MEDIUMINT', label: 'MEDIUMINT' },
  { value: 'INT', label: 'INT' },
  { value: 'BIGINT', label: 'BIGINT' },
  { value: 'FLOAT', label: 'FLOAT' },
  { value: 'DOUBLE', label: 'DOUBLE' },
  { value: 'DECIMAL', label: 'DECIMAL' },
  { value: 'NUMERIC', label: 'NUMERIC' },
  { value: 'BINARY_FLOAT', label: 'BINARY_FLOAT' },
  { value: 'BINARY_DOUBLE', label: 'BINARY_DOUBLE' },
  { value: 'DOUBLE_PRECISION', label: 'DOUBLE_PRECISION' },
  { value: 'REAL', label: 'REAL' },
  { value: 'CHAR', label: 'CHAR' },
  { value: 'VARCHAR', label: 'VARCHAR' },
  { value: 'TINYTEXT', label: 'TINYTEXT' },
  { value: 'TEXT', label: 'TEXT' },
  { value: 'MEDIUMTEXT', label: 'MEDIUMTEXT' },
  { value: 'LONGTEXT', label: 'LONGTEXT' },
  { value: 'BINARY', label: 'BINARY' },
  { value: 'VARBINARY', label: 'VARBINARY' },
  { value: 'TINYBLOB', label: 'TINYBLOB' },
  { value: 'MEDIUMBLOB', label: 'MEDIUMBLOB' },
  { value: 'BLOB', label: 'BLOB' },
  { value: 'LONGBLOB', label: 'LONGBLOB' },
  { value: 'ENUM', label: 'ENUM' },
  { value: 'SET', label: 'SET' },
  { value: 'DATE', label: 'DATE' },
  { value: 'DATETIME', label: 'DATETIME' },
  { value: 'TIMESTAMP', label: 'TIMESTAMP' },
  { value: 'TIME', label: 'TIME' },
  { value: 'YEAR', label: 'YEAR' },
];

export const postgresDataTypeOptions = [
  { value: 'SMALLINT', label: 'SMALLINT' },
  { value: 'INTEGER', label: 'INTEGER' },
  { value: 'BIGINT', label: 'BIGINT' },
  { value: 'REAL', label: 'REAL' },
  { value: 'DOUBLE PRECISION', label: 'DOUBLE PRECISION' },
  { value: 'NUMERIC', label: 'NUMERIC' },
  { value: 'DECIMAL', label: 'DECIMAL' },
  { value: 'CHARACTER VARYING', label: 'CHARACTER VARYING' },
  { value: 'CHARACTER', label: 'CHARACTER' },
  { value: 'TEXT', label: 'TEXT' },
  { value: 'DATE', label: 'DATE' },
  { value: 'TIME', label: 'TIME' },
  { value: 'TIMESTAMP', label: 'TIMESTAMP' },
  { value: 'INTERVAL', label: 'INTERVAL' },
  { value: 'BYTEA', label: 'BYTEA' },
  { value: 'BIT VARYING', label: 'BIT VARYING' },
  { value: 'BIT', label: 'BIT' },
  { value: 'BOOL', label: 'BOOL' },
  { value: 'BOOLEAN', label: 'BOOLEAN' },
  { value: 'UUID', label: 'UUID' },
  { value: 'ARRAY', label: 'ARRAY' },
  { value: 'JSON', label: 'JSON' },
  { value: 'JSONB', label: 'JSONB' },
  { value: 'INT4RANGE', label: 'INT4RANGE' },
  { value: 'INT8RANGE', label: 'INT8RANGE' },
  { value: 'NUMRANGE', label: 'NUMRANGE' },
  { value: 'TSRANGE', label: 'TSRANGE' },
  { value: 'TSTZRANGE', label: 'TSTZRANGE' },
  { value: 'DATERANGE', label: 'DATERANGE' },
  { value: 'INT4RANGE', label: 'INT4RANGE' },
  { value: 'INT8RANGE', label: 'INT8RANGE' },
  { value: 'NUMRANGE', label: 'NUMRANGE' },
  { value: 'TSRANGE', label: 'TSRANGE' },
  { value: 'TSTZRANGE', label: 'TSTZRANGE' },
  { value: 'DATERANGE', label: 'DATERANGE' },
  { value: 'INT4RANGE', label: 'INT4RANGE' },
  { value: 'INT8RANGE', label: 'INT8RANGE' },
  { value: 'NUMRANGE', label: 'NUMRANGE' },
  { value: 'TSRANGE', label: 'TSRANGE' },
  { value: 'TSTZRANGE', label: 'TSTZRANGE' },
];

export const isStringDataType = (datatype: string) => {
  if (
    datatype === COLUMN_DATATYPES.CHAR ||
    datatype === COLUMN_DATATYPES.NCHAR ||
    datatype === COLUMN_DATATYPES.VARCHAR ||
    datatype === COLUMN_DATATYPES.NVARCHAR ||
    datatype === COLUMN_DATATYPES.VARCHAR2 ||
    datatype === COLUMN_DATATYPES.NVARCHAR2 ||
    datatype === COLUMN_DATATYPES.TINYTEXT ||
    datatype === COLUMN_DATATYPES.TEXT ||
    datatype === COLUMN_DATATYPES.NTEXT ||
    datatype === COLUMN_DATATYPES.MEDIUMTEXT
  ) {
    return true;
  }
  return false;
};

export const getColorFromConstraint = (constraintType: string) => {
  switch (constraintType) {
    case COLUMN_CONSTRAINTS.PRIMARY_KEY:
      return 'green';
    case COLUMN_CONSTRAINTS.NOT_NULL:
      return 'red';
    case COLUMN_CONSTRAINTS.UNIQUE:
      return 'cyan';
    case COLUMN_CONSTRAINTS.AUTO_INCREMENT:
      return 'yellow';
    case COLUMN_CONSTRAINTS.FOREIGN_KEY:
      return 'purple';
    default:
      return 'primary';
  }
};
